// [], and {}
const isEmpty = value => (
  (Array.isArray(value) && value.length < 1) || (typeof value === 'object' && Object.keys(value).length === 0)
);

export default isEmpty;
